module.exports = __webpack_public_path__ + "static/media/back.ddba514e.png";